var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading"},[_c('h1',{staticClass:"headline headline--h2 headline--alternate",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('small',{domProps:{"innerHTML":_vm._s(_vm.subtitle)}})])}
var staticRenderFns = []

export { render, staticRenderFns }